import React from "react";
import { T } from "../app/tokens.js";

export function KpiPopover({ period, source, children, details }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <div
        data-testid="home-kpi-popover-description"
        style={{
          padding: "13px 17px 12px",
          flex: 1,
          color: T.lightGray,
          fontSize: T.fsXs,
          lineHeight: 1.55,
          whiteSpace: "normal",
        }}
      >
        {children}
      </div>
      {details?.length > 0 && (
        <div style={{ padding: "0 17px 12px", display: "flex", flexDirection: "column", gap: 4 }}>
          {details.map((row) => (
            <div key={row.label} style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
              <span style={{ color: T.homeKpiPopover.label, fontSize: T.fsXs }}>{row.label}</span>
              <span style={{ color: T.tooltip.fg, fontSize: T.fsXs, fontWeight: T.fwBold }}>{row.value}</span>
            </div>
          ))}
        </div>
      )}
      <div data-testid="home-kpi-popover-divider" style={{ height: 1, background: "rgba(255,255,255,.12)", flexShrink: 0 }} />
      <div
        data-testid="home-kpi-popover-footer"
        style={{
          padding: "10px 17px 12px",
          display: "flex",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <div data-testid="home-kpi-popover-period" style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
          <span style={{ color: T.homeKpiPopover.label, fontSize: T.fsXs, fontWeight: T.fwBold, whiteSpace: "nowrap" }}>As Of:</span>
          <span style={{ color: T.homeKpiPopover.asOf, fontSize: T.fsXs, fontWeight: T.fwBold }}>{period}</span>
        </div>
        <div data-testid="home-kpi-popover-source" style={{ display: "flex", alignItems: "baseline", gap: 7 }}>
          <span style={{ color: T.homeKpiPopover.label, fontSize: T.fsXs, fontWeight: T.fwBold, whiteSpace: "nowrap" }}>Source:</span>
          <span style={{ color: T.tooltip.fg, fontSize: T.fsXs, fontWeight: T.fwBold }}>{source}</span>
        </div>
      </div>
    </div>
  );
}

export const HOME_KPI_TOOLTIP_STYLE = {
  width: 270,
  maxWidth: "calc(100vw - 24px)",
  boxSizing: "border-box",
  padding: 0,
  borderRadius: 11,
  overflow: "hidden",
};